import { render, staticRenderFns } from "./OrderLD.vue?vue&type=template&id=a52e0dd0&scoped=true"
import script from "./OrderLD.vue?vue&type=script&lang=js"
export * from "./OrderLD.vue?vue&type=script&lang=js"
import style0 from "./OrderLD.vue?vue&type=style&index=0&id=a52e0dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52e0dd0",
  null
  
)

export default component.exports